import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ErrorType } from 'src/app/enums/error-type.enum';
import endpoints from 'src/app/helpers/endpoints';
import { ApiService } from 'src/app/services/api.service';
import { CommonService } from 'src/app/services/common.service';
import { CustomerDashboardService } from '../../services/customer-dashboard.service';

@Component({
  selector: 'fury-common-label-section',
  templateUrl: './common-label-section.component.html',
  styleUrls: ['./common-label-section.component.scss']
})
export class CommonLabelSectionComponent implements OnInit, OnDestroy {
  claimId = '';
  userId = '';
  agreementId = '';
  labelDetails: any = null;
  ngUnsubscribe = new Subject<void>();
  @Input() mainPage:string;

  constructor(
    private apiService: ApiService,
    private activateRoute: ActivatedRoute, 
    public commonService: CommonService,
    private customerDashboardService: CustomerDashboardService
  ) { }

  ngOnInit(): void {
    this.customerDashboardService.shouldFetchLabel$.pipe(takeUntil(this.ngUnsubscribe)).subscribe({
      next: (res: boolean) => {
        if(res && this.agreementId) this.getAgreementLabel();
      }
    })
    if(this.mainPage === 'viewClaim')
    {
      this.claimId = this.activateRoute.snapshot.params["claimId"];
      this.apiService
      .get(endpoints.customerDashboard.getFileClaimLabel(this.claimId))
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if (res?.body) {
            this.labelDetails = res.body?.labelDetail;
          }
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err.error?.message, ErrorType.Error);
        },
      });
    }

    else if (this.mainPage === 'customerDashboard'){
      this.userId = this.activateRoute.snapshot.params["id"];
      this.apiService
      .get(endpoints.customerDashboard.getCustomerDashboardLabel(this.userId))
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if (res?.body) {
            this.labelDetails = res.body?.labelDetail;
          }
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err.error?.message, ErrorType.Error);
        },
      });
    }
    else {
      this.agreementId = this.activateRoute.snapshot.params["agreementId"];
      if(this.agreementId) this.getAgreementLabel();
    }
  }
  getAgreementLabel(){
    this.apiService
      .get(endpoints.customerDashboard.getAgreementLabel(this.agreementId))
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if (res?.body) {
            this.labelDetails = res.body?.labelDetail;
          }
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err.error?.message, ErrorType.Error);
        },
      });
  }


  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
